import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { Box, Button, CircularProgress, Radio } from "@mui/material";
import image from "../Images/Email-campaign-pana-1.svg";
import singleImage from "../Images/Email campaign-pana 1.svg";
import BulkamilAddManually from "../Images/bulkmail_add_manually.svg";
import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { TextField } from "@mui/material";
import BaseUrl from "../BaseUrl";
import axios from "axios";
import { read, utils } from "xlsx";
import { saveAs } from "file-saver";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import io from "socket.io-client";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Divider, Menu, MenuItem } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useHistory } from "react-router-dom";
import * as XLSX from "xlsx/xlsx.mjs";
import fileUploadImg from "../Images/uploadFile.svg";
import { useLocation } from "react-router-dom";
import Mailverification from "./Mailverification";
import { useFormik, isValid } from "formik";
import { verifySingleMailSchema } from "../Schemas/ChangePassword";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
var socket = io.connect(BaseUrl.baseurl, {
  transports: ["websocket"],
});
const breadcrumbs = [
  <p
    style={{
      color: "#1C485F",
      fontFamily: "Source Sans 3",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 500,
    }}
  >
    Email Verification
  </p>,
  <p
    style={{
      color: "#1C485F",
      fontFamily: "Source Sans 3",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 500,
    }}
  >
    Bulk Email Verification
  </p>,
];

const bultOptions = [
  {
    id: 1,
    text: "Add from file",
  },
  {
    id: 2,
    text: "Add manually",
  },
];
function createData(name, calories, fat, carbs, protein) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
  };
}

const rows = [
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Donut", 452, 25.0, 51, 4.9),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
];

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "progress",
    numeric: true,
    disablePadding: false,
    label: "Progress",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "added",
    numeric: true,
    disablePadding: false,
    label: "Added",
  },
  // {
  //   id: "move to list",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Move to list",
  // },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "center" : "left"}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              color: "#4B4B4B",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 700,
            }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function BulkMailVerification() {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [activeOption, setActiveOption] = useState(1);
  const [contacts, setContacts] = useState([]);
  const [uploadedList, setUploadedList] = useState([]);
  const [csvName, setCsvName] = useState("");
  const [nameIndex, setNameIndex] = useState("");
  const [mailIndex, setMailIndex] = useState("");
  const [phoneIndex, setPhoneIndex] = useState("");
  const [listName, setListName] = useState("");
  const [manualEmail, setManualEmail] = useState("");
  const [fileType, setFileType] = useState("CSV");
  const [csvData, setCsvData] = useState([]);
  const [socketCount, setSocketCount] = useState([]);
  const [fileLists, setFileLists] = useState([]);
  const [fileListsCopy, setFileListsCopy] = useState([]);
  const [fileLoader, setFileLoader] = useState(false);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [manualStatus, setManualStatus] = useState(false);
  const [open, setOpen] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [order, setOrder] = useState("asc");
  const [selectedBulkId, setSelectedBulkId] = useState("");
  const [selectedBulk, setSelectedBulk] = useState([]);
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [showToaster, setShowToaster] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const getAllAddedFileNameList = () => {
    const api = `${
      BaseUrl.baseurl
    }/email-marketing/user-email/get-bulk-email-data/${
      userDetails && userDetails.details._id
    }`;
    axios
      .get(api, {
        headers: {
          Authorization: `Bearer ${userDetails && userDetails.token}`,
        },
      })
      .then((response) => {
        if (response.data.status) {
          setFileLists(response.data.details);
          setFileListsCopy(response.data.details);
          let vig = [];
          response.data.details.map((val) => {
            vig.push({
              id: val._id,
              VerifiedCount: val.VerifiedCount,
              NotVerifiedCount: (val.ToEmail.length-(val.VerifiedCount+val.NonVerifiableCount)),
              NonVerifiableCount: val.NonVerifiableCount,
              GreyCount: val.GreyCount,
              BlockedCount: val.BlockedCount,
              from: "api",
              totalCount:
                val.VerifiedCount +
                (val.ToEmail.length-(val.VerifiedCount+val.NonVerifiableCount)) +
                val.NonVerifiableCount,
            });
          });
          setSocketCount(vig);
        } else {
          setFileLists([]);
          setFileListsCopy([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    getAllAddedFileNameList();
  }, []);

  useEffect(() => {
    socket.on(
      `${userDetails && userDetails.details._id}-verification-email-status`,
      (data) => {
        if (data.verifyStatus) {
          getAllAddedFileNameList();
        }
        setSocketCount([
          {
            id: data.builkId,
            VerifiedCount: data.verifiedCount,
            NotVerifiedCount: (data.totalCount-(data.verifiedCount+data.nonVerifiableCount)),
            NonVerifiableCount: data.nonVerifiableCount,
            GreyCount: data.greyCount,
            BlockedCount: data.blockedCount,
            from: "socket",
            totalCount:
              data.verifiedCount +
              (data.totalCount-(data.verifiedCount+data.nonVerifiableCount)) +
              data.nonVerifiableCount,
          },
        ]);
      }
    );
  }, []);
  const triggerFileInput = () => {
    // setOpen3(false);

    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".csv, .xlsx, .txt";
    fileInput.style.display = "none";

    // Attach an event listener to the file input to handle the file selection
    fileInput.addEventListener("change", handleFileUpload);

    // Trigger a click event on the file input to open the file selection dialog
    fileInput.click();
  };
  function verifyBulkEmailById(bulkId) {
    setVerifyLoader(true);
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user-email/verify-bulk-email/${
        userDetails && userDetails.details._id
      }/${bulkId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          getAllAddedFileNameList();
          // setShowToaster(true)
          // toast.success(response.data.message,{autoClose: true,position:"top-right",duration: 3000});
        } else {
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setVerifyLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const isSupportedEncoding = (fileContent) => {
    const utf8Regex = /[\x80-\xFF]/;
    return !utf8Regex.test(fileContent);
  };
  function isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}
  const handleFileUpload = (event) => {
   
    setFileLoader(true);
    const selectedFiles = event.target.files;
    let fileName;
    console.log('file enytered',selectedFiles)
    if (selectedFiles.length > 0) {
      setCsvName(selectedFiles[0].name);
      fileName = selectedFiles[0].name;
      const file = selectedFiles[0];
      // eslint-disable-next-line
      languageEncoding(file).then((fileInfo) => {
        if (fileInfo.encoding === null || fileInfo.encoding !== "UTF-16LE") {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileContent = e.target.result;
            // Use xlsx to parse the XLSX data
            const workbook = read(fileContent, { type: "binary" });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            const jsonData = utils.sheet_to_json(sheet, { header: 1 });
            // The parsed XLSX data is in jsonData
            let nameIdx, mailIdx, phoneIdx;
            for (let i = 0; i < jsonData[0].length; i++) {
              console.log('jsondata',jsonData[0][i])
              if(jsonData[0][i]!==undefined){
                if (jsonData[0][i].toString().toLowerCase().includes("name")||jsonData[0][i].toString().toLowerCase().includes("user")||jsonData[0][i].toString().toLowerCase().includes("customer")) {
                  setNameIndex(i);
                  nameIdx = i;
                }
                if (jsonData[0][i].toString().toLowerCase()==="email"||jsonData[0][i].toString().toLowerCase()==="mail"||jsonData[0][i].toString().toLowerCase()==="gmail") {
                  setMailIndex(i);
                  mailIdx = i;
                }
                if (jsonData[0][i].toString().toLowerCase().includes("phone")) {
                  setPhoneIndex(i);
                  phoneIdx = i;
                }
              }
             
            }

            setCsvData(jsonData.slice(1));
            let toEmailData=[]
            jsonData.slice(1).map((val) => {
              if(val[mailIdx] !== undefined&&val[mailIdx] !== ""&&isValidEmail(val[mailIdx])){
                
                let vig = {
                  Name: val[nameIdx] === undefined ? "" : val[nameIdx],
                  Email: val[mailIdx] === undefined ? "" : val[mailIdx],
                  Phone:
                    val[phoneIdx] === undefined
                      ? 0
                      : isNaN(val[phoneIdx])
                      ? 0
                      : parseInt(val[phoneIdx]),
                  Verified: false,
                  VerifiedStatus: "Not Verified",
                  OldValue:val
                };
                
                toEmailData.push(vig);
              } 
            })
            const uploadedData = {
              filename: fileName,
              toEmail: toEmailData
            };
            // console.log("after uploading file=========>", uploadedData);
            const api = `${
              BaseUrl.baseurl
            }/email-marketing/user-email/store-bulk-email-upload/${
              userDetails && userDetails.details._id
            }`;
            axios
              .post(
                api,
                {
                  data: JSON.stringify(uploadedData),
                },
                {
                  headers: {
                    Authorization: `Bearer ${userDetails && userDetails.token}`,
                  },
                }
              )
              .then((response) => {
                if (response.data.status) {
                  setShowToaster(true);
                  toast.success(response.data.message, {
                    autoClose: true,
                    position: "top-right",
                    duration: 3000,
                  });
                  getAllAddedFileNameList();
                } else {
                  setShowToaster(true);
                  toast.error(response.data.message, {
                    autoClose: true,
                    position: "top-right",
                    duration: 3000,
                  });
                  if (response.data.tokenExpire) {
                    localStorage.removeItem("MailSenderuserDetails");
                    window.location.reload();
                  }
                }
                setFileLoader(false);
              })
              .catch((error) => {
                toast.error("error in storing file", {
                  autoClose: true,
                  position: "top-right",
                  duration: 3000,
                });
                setFileLoader(true);
                console.error("Error:", error);
              });
          };
          reader.readAsBinaryString(file);
        } else {
          setOpen5(true);
          return;
        }
      });
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  function deleteBulkFIle() {
    setOpen(false);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/user-email/delete-bulk-email-data/${
        userDetails && userDetails.details._id
      }/${selectedBulkId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          getAllAddedFileNameList();
          setShowToaster(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const statusArr = [
    {
      id: 1,
      hex: "#53D86A",
      value: 0,
      name: "verified",
    },
    {
      id: 2,
      hex: "#FFCB2F",
      value: 0,
      name: "We can't guarantee email validity",
    },
    {
      id: 3,
      hex: "#FF3434",
      value: 0,
      name: "Not Verified",
    },
    {
      id: 4,
      hex: "#868686",
      value: 0,
      name: "Grey-listed Emails",
    },
    {
      id: 5,
      hex: "#000000",
      value: 0,
      name: "Blocked",
    },
  ];
  const [downloadStatusArr, setDownloadStatusArr] = useState([
    {
      id: 1,
      hex: "#53D86A",
      value: 0,
      name: "Valid Emails",
      status: true,
    },

    {
      id: 2,
      hex: "#FF3434",
      value: 0,
      name: "Invalid Emails",
      status: false,
    },
  ]);
  const downloadFileArr = [
    {
      id: 1,

      name: "CSV",
    },
    {
      id: 2,

      name: "XLSX",
    },
    // {
    //   id: 3,

    //   name: "Google sheets",
    // },
  ];
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid transparent",
    borderRadius: "7px",
    boxShadow: 24,
    p: 2,
  };
  const handleClose = () => setOpen1(false);
  const [open1, setOpen1] = useState(false);
  const [toEmailList, setToEmailList] = useState([]);
  const [nameListArr, setNameListArr] = useState([]);
  const [nameList, setNameList] = useState("");
  const [nameListObj, setNameListObj] = useState("");
  const [searchRecords, setSearchRecords] = useState("");
  const [activeMailCardId, setActiveMailCardId] = useState(null);
  const [singleMail, setSingleMail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [isPassed, setIsPassed] = useState(false);

  function getAllNameList() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/contact/get-all-name-list/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setNameListArr(response.data.details);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllNameList();
  }, [isPassed]);

  const handleChange6 = (event) => {
    setNameList(event.target.value);
    nameListArr.map((val) => {
      if (val.Name === event.target.value) {
        setNameListObj(val);
      }
    });
  };
  function addContactToNameList() {
    let contactData = {
      Contact: toEmailList.map((val) => {
        let vig = {
          Name: val.Name,
          Email: val.Email,
          Phone: val.Phone,
          Subscriber: false,
          Blocked: false,
          SendingOption: val.VerifiedStatus,
        };
        return vig;
      }),
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/contact/create-contact/${
          userDetails && userDetails.details._id
        }`,
        { data: JSON.stringify(contactData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          let nameListData = {
            contact: toEmailList.map((val) => {
              let single = {
                Name: val.Name,
                Email: val.Email,
                Phone: val.Phone,
                SendingOption: val.VerifiedStatus,
              };
              return single;
            }),
          };
          axios
            .put(
              `${
                BaseUrl.baseurl
              }/email-marketing/contact/add-contact-name-list/${
                userDetails && userDetails.details._id
              }/${nameListObj._id}`,
              nameListData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              console.log("rres", response);
              if (response.data.status) {
                setOpen1(false);
                setShowToaster(true);
                toast.success(response.data.message, {
                  autoClose: true,
                  position: "top-right",
                  duration: 3000,
                });
              } else {
                setShowToaster(true);
                toast.error(response.data.message, {
                  autoClose: true,
                  position: "top-right",
                  duration: 3000,
                });
                if (response.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
        } else {
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function getEmailName(email) {
    const atIndex = email.indexOf("@"); // Find the position of the '@' symbol
    if (atIndex !== -1) {
      const name = email.slice(0, atIndex); // Extract the part before '@'
      return name;
    } else {
      return "Invalid email address";
    }
  }
  function isValidEmail(email) {
    // Regular expression pattern for a basic email validation
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    // Test the email against the pattern
    return emailPattern.test(email);
  }
  function addManualEmail() {
    setManualStatus(true);
    const uploadedData = {
      filename: listName,
      toEmail: manualEmail.split(",").map((val) => {
        if (isValidEmail(val)) {
          return {
            Name: getEmailName(val),
            Email: val,
            Phone: 0,
            Verified: false,
            VerifiedStatus: "Not Verified",
          };
        }
      }),
    };
    console.log("dkjkdkkdk", uploadedData);
    const api = `${
      BaseUrl.baseurl
    }/email-marketing/user-email/store-bulk-email-upload/${
      userDetails && userDetails.details._id
    }`;
    axios
      .post(
        api,
        {
          data: JSON.stringify(uploadedData),
        },
        {
          headers: {
            Authorization: `Bearer ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          getAllAddedFileNameList();
          setListName("");
          setManualEmail("");
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setManualStatus(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Something went wrong...", {
          autoClose: true,
          position: "top-right",
          duration: 3000,
        });
      });
    setShowToaster(true);
  }
  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open1}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open1}>
          <Box sx={style}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h1"
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#4B4B4B",
                }}
              >
                Add to list
              </Typography>
              <Button
                type="button"
                style={{
                  display: "flex",
                  outline: "none",
                  transform: "none",
                  justifyContent: "flex-end",
                  padding: "0px",
                }}
                onClick={() => setOpen1(false)}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Box>

            <Typography
              style={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#4B4B4B",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              List name
            </Typography>
            <FormControl
              variant="filled"
              style={{ minWidth: "100%", margin: "6px 0px" }}
            >
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={nameList}
                disableUnderline
                onChange={handleChange6}
                IconComponent={ArrowDropDownIcon}
                sx={{
                  color: "var(--color-dark-600, #727272)",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                  background: "var(--background-color, #FAFAFA)",
                }}
              >
                {nameListArr.length !== 0 &&
                  nameListArr.map((val) => {
                    return (
                      <MenuItem
                        sx={{
                          color: "var(--color-dark-600, #727272)",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "20px",
                        }}
                        value={val.Name}
                      >
                        {val.Name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <Button
                onClick={() => setOpen1(false)}
                style={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  addContactToNameList();
                }}
                style={{
                  textTransform: "none",
                  background: "#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Add
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };
  function downloadBulk(exportJson) {
    setOpen3(false);
    if (fileType === "CSV") {
      // console.log("selectedbulk", exportJson);

      const csvContent = "data:text/csv;charset=utf-8," + JSONToCSV(exportJson);
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${selectedBulk.FileName}.csv`);
      link.click();
    } else if (fileType === "XLSX") {
      const ws = XLSX.utils.json_to_sheet(exportJson);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `${selectedBulk.FileName}.xlsx`);
    }
  }

  const handleSearchRecords = (e) => {
    const inputValue = e.target.value.toLowerCase();
    setSearchRecords(inputValue);
    const results = fileListsCopy.filter((file) =>
      file.FileName.toLowerCase().includes(inputValue)
    );
    setFileLists(results);
  };

  const EnhancedTableToolbar = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "4px 16px",
          borderBottomWidth: "1.2px",
          marginBottom: "12px",
        }}
      >
        <Button
          disableRipple
          disableElevation
          sx={{
            cursor: "default",
            outline: "none !important",
            borderBottom: "2px solid #1C485F",
            borderRadius: 0,
            color: "#1C485F",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Typography
            style={{
              color: "#1C485F",
              fontSize: "15px",
              fontWeight: 700,
              fontFamily: "Source Sans 3",
            }}
            component="h2"
          >
            Verified Bulk Email List
          </Typography>
        </Button>
        <div
          style={{
            position: "relative",
            backgroundColor: "#FAFAFA",
            border: "1px solid #1C485F",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            padding: "0px 12px 0px 0px",
          }}
        >
          <input
            type="text"
            placeholder="Search"
            value={searchRecords}
            name="search list name"
            onChange={handleSearchRecords}
            style={{
              backgroundColor: "transparent",
              padding: "12px",
              width: "250px",
              outline: "none",
            }}
          />
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M7.66666 14C11.1645 14 14 11.1644 14 7.66665C14 4.16884 11.1645 1.33331 7.66666 1.33331C4.16886 1.33331 1.33333 4.16884 1.33333 7.66665C1.33333 11.1644 4.16886 14 7.66666 14Z"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.6667 14.6666L13.3333 13.3333"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </Box>
    );
  };

  const JSONToCSV = (data) => {
    const keys = Object.keys(data[0]);
    const csvData = [keys.join(",")];

    for (let item of data) {
      const values = keys.map((key) => item[key]);
      csvData.push(values.join(","));
    }

    return csvData.join("\n");
  };

  const isEmailValid = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  };

  const handleVerifyEmail = (values, actions) => {
    if (isEmailValid(values.email)) {
      const api = `${
        BaseUrl.baseurl
      }/email-marketing/user-email/email-verify-status/${
        userDetails && userDetails.details._id
      }`;
      axios
        .post(
          api,
          { email: values.email, name: getEmailName(values.email) },
          {
            headers: {
              Authorization: `Bearer ${userDetails && userDetails.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            setIsPassed(!isPassed);
            setShowToaster(true);
            toast.success(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
          } else {
            setIsPassed(!isPassed);
            setShowToaster(true);
            toast.error(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
            if (response.data.tokenExpire) {
              localStorage.removeItem("MailSenderuserDetails");
              window.location.reload();
            }
          }
          // setShowToaster(true);
          // // fetchingIndividualEmails();
          //  toast.success(response.data.message,{autoClose: true,position:"top-right",duration:3000});
        })
        .catch((error) => {
          console.error("Error:", error);
        });
      actions.resetForm();
    }
  };

  const forgotFormik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: verifySingleMailSchema,
    onSubmit: handleVerifyEmail,
  });

  const displayCards = () => {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2,1fr)",
          gap: "12px",
          padding: "14px 16px",
        }}
      >
        <div
          onClick={() => {
            history.push("/BulkMailVerification");
            setActiveMailCardId(null);
          }}
          className={
            location.pathname === "/BulkMailVerification" &&
            activeMailCardId === null
              ? "mail-card-active"
              : "mail-card-inActive"
          }
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            borderRadius: "6px",
            padding: "12px",
            cursor: "pointer",
          }}
        >
          <p
            style={{
              color: "#4B4B4B",
              fontFamily: "Source Sans 3",
              fontSize: "22px",
              fontWeight: 700,
              fontStyle: "normal",
            }}
          >
            Verify Bulk Email
          </p>
          <p
            style={{
              color: "#727272",
              fontFamily: "Source Sans 3",
              fontSize: "13px",
              fontStyle: "normal",
              marginTop: "0px",
              marginBottom: "6px",
            }}
          >
            Verify emails in bulk using our multilayer verification process that
            includes syntax check, MX record check, and SMTP authentication.
          </p>
          <div
            onClick={triggerFileInput}
            style={{
              backgroundColor: "#fff",
              borderRadius: "6px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
              width: "100%",
              border: "1px solid #DDD",
              padding: "12px 0px",
              boxShadow: "rgba(0, 0, 0, 0.12) 0px 3px 8px",
            }}
          >
            <button
              style={{
                outline: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {fileLoader ? (
                <CircularProgress
                  size={45}
                  style={{
                    color: "#1C485F",
                  }}
                />
              ) : (
                <img src={fileUploadImg} loading="lazy" alt="filUpload-iamge" />
              )}
            </button>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <p
                style={{
                  color: "#4B4B4B",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 700,
                }}
              >
                Upload a file
              </p>
              <p
                style={{
                  maxWidth: "290px",
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "12px",
                  fontStyle: "normal",
                  textAlign: "center",
                  marginTop: "0px",
                }}
              >
                Bulk Email Verification tool supports CSV, XLS, XLSX and TXT
                file formats and can process up to 100,000 lines per search.
              </p>
            </div>
          </div>
        </div>
        <div
          onClick={() => history.push("/EmailVerify")}
          className={
            location.pathname === "/EmailVerify"
              ? "mail-card-active"
              : "mail-card-inActive"
          }
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            borderRadius: "6px",
            padding: "12px",
            cursor: "pointer",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p
              style={{
                color: "#4B4B4B",
                fontFamily: "Source Sans 3",
                fontSize: "22px",
                fontWeight: 700,
                fontStyle: "normal",
              }}
            >
              Verify Single Email
            </p>
            <img
              src={singleImage}
              alt="individual email"
              style={{ height: "118px" }}
              loading="lazy"
            />
          </div>
          <form
            onSubmit={forgotFormik.handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "14px" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                position: "relative",
              }}
            >
              <label htmlFor="user-email">
                Type in an email for verification
              </label>
              <input
                type="email"
                autoComplete="off"
                onBlur={forgotFormik.handleBlur}
                value={forgotFormik.values.email}
                name="email"
                id="user-email"
                onChange={forgotFormik.handleChange}
                style={{
                  padding: "12px 8px",
                  outline: "none",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                }}
                placeholder="Enter your email address"
              />
              {/* {forgotFormik.values.email.length !== 0 && !forgotFormik.isValid &&
             <p style={{ color: "red",position: "absolute",
                  bottom: -23,
                  left: 0, }}>{forgotFormik.errors.email}</p>} */}
              {/* {emailError && (
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  bottom: -15,
                  left: 0,
                }}
              >
                *Please enter a valid email address.
              </span>
            )} */}
            </div>
            <button
              disabled={forgotFormik.values.email.length === 0}
              type="submit"
              style={{
                padding: "8px 22px",
                marginTop: "10px",
                borderRadius: "4px",
                color: "#fff",
                outline: "none",
                fontFamily: "Source Sans 3",
                fontWeight: 400,
                fontStyle: "normal",
              }}
              className="bg-primary"
            >
              Verify
            </button>
          </form>
        </div>
        {/* <div onClick={()=>{
          history.push("/BulkMailVerification")
          setActiveMailCardId(3)
        }} 
      className={location.pathname === "/BulkMailVerification" && activeMailCardId === 3 ? "mail-card-active" : 'mail-card-inActive'} style={{display:"flex",flexDirection:"column",gap:"12px",borderRadius:'6px',padding:'12px',cursor:"pointer"}}>
        <p
        style={{
            color: "#4B4B4B",
            fontFamily: "Source Sans 3",
            fontSize: "22px",
            fontWeight: 700,
            fontStyle: "normal",
            }}
        >
        Verify Bulk Email(Manually)
        </p>
        <div style={{display:"flex",flexDirection:"column",gap:'10px'}}>
            <label htmlFor="list-name" 
            style={{display:"flex",alignItems:"center",gap:'12px',
            fontFamily: "Source Sans 3",
            fontSize: "13px",
            fontWeight: 400,
            fontStyle: "normal",
            color:"#393939"
            }}
            >
                Prospect list name
              <Tooltip sx={{backgroundColor:"red",width:"200px"}}
                title="We'll create a new prospect list with the addresses you add for verification." placement="top"
                arrow
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10.0002 1.66634C5.41683 1.66634 1.66683 5.41634 1.66683 9.99967C1.66683 14.583 5.41683 18.333 10.0002 18.333C14.5835 18.333 18.3335 14.583 18.3335 9.99967C18.3335 5.41634 14.5835 1.66634 10.0002 1.66634Z"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 13.333V9.16634"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.0044 6.66699H9.99691"
                  stroke="#292D32"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              </Tooltip>
            </label>
            <input
            value={listName}
            onChange={(e) => {
            setListName(e.target.value);
          }}
            autoComplete="off"
                        type="text" id='list-name' style={{padding:"12px 8px",outline:"none",backgroundColor:"#FAFAFA",borderRadius:"4px",border:'1px solid #1C485F',}} 
            placeholder='Enter new list name'
            />
                      </div>
          <div style={{display:"flex",flexDirection:"column",gap:'10px'}}>
              <label htmlFor="email-addresses" 
              style={{display:"flex",alignItems:"center",gap:'12px',
              fontFamily: "Source Sans 3",
              fontSize: "13px",
              fontWeight: 400,
              fontStyle: "normal",
              color:"#393939"
              }}>
                  Email addresses for verification
                  <Tooltip title="We'll create a new prospect list with the addresses you add for verification." sx={{backgroundColor:"red",width:"200px"}} placement="top" arrow>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M10.0007 1.66536C5.41732 1.66536 1.66732 5.41536 1.66732 9.9987C1.66732 14.582 5.41732 18.332 10.0007 18.332C14.584 18.332 18.334 14.582 18.334 9.9987C18.334 5.41536 14.584 1.66536 10.0007 1.66536Z" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10 13.332V9.16536" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10.0039 6.66797H9.99642" stroke="#292D32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </Tooltip>
              </label>
              <textarea
              autoComplete="off"
              value={manualEmail}
              onChange={(e) => {
              setManualEmail(e.target.value);
              }}
               
                style={{resize:"none",backgroundColor:"#FAFAFA",borderRadius:"4px",padding:"12px 8px",outline:"none",border:'1px solid #1C485F'}} name="emails" id="email-addresses" cols="30" rows="3" placeholder='Enter email address separating them with commas, semicolons, spaces or line breaks'></textarea>
                        </div>
          <button
            style={{pointerEvents:(!listName||!manualEmail)&&'none',padding: "8px 22px",
            borderRadius: "4px",
            color: "#fff",
            outline: "none",
            backgroundColor:"#1C485F",
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontStyle: "normal",
            display:"flex",
            alignItems: "center",
            justifyContent: "center",
            gap:'14px',
            }}
            onClick={()=>{
            addManualEmail()
            }}
                        >
              {
                manualStatus && 
                <CircularProgress
                size={20}
                style={{
                  color: "#FFF",
                }}
              />
              }
            Verify emails
          </button>
                </div> */}
      </div>
    );
  };

  const bulkUiComponent = () => {
    return (
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2, boxShadow: "none" }}>
          {EnhancedTableToolbar()}
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="small"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              {fileLists.length !== 0 && (
                <TableBody>
                  {fileLists.map((dataObj, index) => {
                    const isItemSelected = isSelected(dataObj.name);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    const isOddRow = index % 2 === 0; // Check if the row is odd

                    // Define the background color based on row type
                    const rowStyle = isOddRow
                      ? { backgroundColor: "#FAFAFA" } // Style for odd rows
                      : { backgroundColor: "#FFF" }; // Style for even rows
                    return (
                      <TableRow
                        onClick={(event) => handleClick(event, dataObj.name)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={dataObj._id}
                        sx={{ cursor: "pointer", ...rowStyle }}
                      >
                        <TableCell sx={{ padding: 0, borderBottom: "none" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              color: "#4B4B4B",
                              fontSize: "12px",
                              fontFamily: "Source Sans 3",
                              fontStyle: "normal",
                              paddingLeft: "14px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M14.6673 7.33301V11.333C14.6673 13.9997 14.0007 14.6663 11.334 14.6663H4.66732C2.00065 14.6663 1.33398 13.9997 1.33398 11.333V4.66634C1.33398 1.99967 2.00065 1.33301 4.66732 1.33301H5.66732C6.66732 1.33301 6.88732 1.62634 7.26732 2.13301L8.26732 3.46634C8.52065 3.79967 8.66732 3.99967 9.33398 3.99967H11.334C14.0007 3.99967 14.6673 4.66634 14.6673 7.33301Z"
                                stroke="#868686"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                              />
                              <path
                                d="M5.33398 1.33301H11.334C12.6673 1.33301 13.334 1.99967 13.334 3.33301V4.25301"
                                stroke="#868686"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            {dataObj.FileName}
                          </div>
                        </TableCell>
                        <TableCell sx={{ padding: 0, borderBottom: "none" }}>
                          <div
                            style={{
                              display: "flex",

                              gap: "6px",
                            }}
                          >
                            {dataObj.Status === "Ongoing" ? (
                              <CircularProgress
                                size={12}
                                style={{
                                  color: "#53D86A",
                                }}
                              />
                            ) : dataObj.Status === "Completed" ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M5.58691 8.00005L7.19358 9.61339L10.4136 6.38672"
                                  stroke="#53D86A"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M7.16691 1.63289C7.62691 1.23956 8.38025 1.23956 8.84691 1.63289L9.90025 2.53956C10.1002 2.71289 10.4736 2.85289 10.7402 2.85289H11.8736C12.5802 2.85289 13.1602 3.43289 13.1602 4.13956V5.27289C13.1602 5.53289 13.3002 5.91289 13.4736 6.11289L14.3802 7.16622C14.7736 7.62622 14.7736 8.37956 14.3802 8.84622L13.4736 9.89956C13.3002 10.0996 13.1602 10.4729 13.1602 10.7396V11.8729C13.1602 12.5796 12.5802 13.1596 11.8736 13.1596H10.7402C10.4802 13.1596 10.1002 13.2996 9.90025 13.4729L8.84691 14.3796C8.38691 14.7729 7.63358 14.7729 7.16691 14.3796L6.11358 13.4729C5.91358 13.2996 5.54025 13.1596 5.27358 13.1596H4.12025C3.41358 13.1596 2.83358 12.5796 2.83358 11.8729V10.7329C2.83358 10.4729 2.69358 10.0996 2.52691 9.89956L1.62691 8.83956C1.24025 8.37956 1.24025 7.63289 1.62691 7.17289L2.52691 6.11289C2.69358 5.91289 2.83358 5.53956 2.83358 5.27956V4.13289C2.83358 3.42622 3.41358 2.84622 4.12025 2.84622H5.27358C5.53358 2.84622 5.91358 2.70622 6.11358 2.53289L7.16691 1.63289Z"
                                  stroke="#53D86A"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M11.334 13.6663H4.66732C2.66732 13.6663 1.33398 12.6663 1.33398 10.333V5.66634C1.33398 3.33301 2.66732 2.33301 4.66732 2.33301H11.334C13.334 2.33301 14.6673 3.33301 14.6673 5.66634V10.333C14.6673 12.6663 13.334 13.6663 11.334 13.6663Z"
                                  stroke="#868686"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M11.3327 6L9.24601 7.66667C8.55935 8.21333 7.43268 8.21333 6.74601 7.66667L4.66602 6"
                                  stroke="#868686"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            )}

                            <p
                              style={{
                                color: "#4B4B4B",
                                fontSize: "11px",
                                fontFamily: "Source Sans 3",
                                fontStyle: "normal",
                              }}
                            >
                              {dataObj.Status === "Ongoing" ||
                              dataObj.Status === "Completed"
                                ? 
                                socketCount.map((val) => {
                                    if (val.id === dataObj._id) {
                                      return val.totalCount;
                                    }

                                    if (val.from === "socket") {
                                      return (
                                        dataObj.VerifiedCount +
                                        dataObj.NotVerifiedCount +
                                        dataObj.NonVerifiableCount +
                                        dataObj.GreyCount +
                                        dataObj.BlockedCount
                                      );
                                    }
                                  })
                                : `${dataObj.ToEmail.length} emails in file`}
                              {(dataObj.Status === "Ongoing" ||
                                dataObj.Status === "Completed") &&
                                `/${dataObj.ToEmail.length} emails verified`}
                            </p>
                          </div>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, borderBottom: "none" }}
                        >
                          {dataObj.Status === "Ongoing" ||
                          dataObj.Status === "Completed" ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "12px",
                                alignItems: "center",
                                padding: "3px 0px",
                              }}
                            >
                              {statusArr.map((data, idx) => (
                                <Tooltip title={data.name} arrow>
                                  <div
                                    key={data.id}
                                    style={{
                                      display: "flex",
                                      gap: "3px",
                                      alignItems: "center",
                                      width: "5vw",
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "12px",
                                        width: "12px",
                                        backgroundColor: data.hex,
                                        borderRadius: "20px",
                                      }}
                                    ></div>
                                    {/* <p>{idx===0?socketCount.map((sock)=>{if(sock.id===dataObj._id){}}):idx===1?dataObj.NotVerifiedCount:idx===2?dataObj.NonVerifiableCount:0}</p> */}
                                    <p>
                                      {socketCount.map((sock) => {
                                        if (sock.id === dataObj._id) {
                                          if (idx === 0) {
                                            return sock.VerifiedCount;
                                          }
                                          if (idx === 1) {
                                            return sock.NotVerifiedCount;
                                          }
                                          if (idx === 2) {
                                            return sock.NonVerifiableCount;
                                          }
                                          if (idx === 3) {
                                            return sock.GreyCount;
                                          }
                                          if (idx === 4) {
                                            return sock.BlockedCount;
                                          }
                                        }
                                        if (sock.from === "socket") {
                                          if (idx === 0) {
                                            return dataObj.VerifiedCount;
                                          }
                                          if (idx === 1) {
                                            return dataObj.NotVerifiedCount;
                                          }
                                          if (idx === 2) {
                                            return dataObj.NonVerifiableCount;
                                          }
                                          if (idx === 3) {
                                            return dataObj.GreyCount;
                                          }
                                          if (idx === 4) {
                                            return dataObj.BlockedCount;
                                          }
                                        }
                                      })}
                                    </p>
                                  </div>
                                </Tooltip>
                              ))}
                            </div>
                          ) : null}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, borderBottom: "none" }}
                        >
                          <p
                            style={{
                              fontSize: "12px",
                              fontFamily: "Source Sans 3",
                              fontStyle: "normal",
                              color: "#4B4B4B",
                            }}
                          >
                            {new Date(dataObj.CreatedDate).toLocaleString(
                              "en-US",
                              options
                            )}
                          </p>
                        </TableCell>
                        {/* <TableCell
                            align="center"
                            sx={{ padding: 0, borderBottom: "none" }}
                          >
                            {dataObj.Status === "Completed" ? (
                              <div
                                onClick={() => {
                                  setToEmailList(dataObj.ToEmail);
                                  setOpen1(true);
                                }}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  padding: "3px 0px",
                                }}
                              >
                                <button
                                  style={{
                                    fontSize: "10px",
                                    borderRadius: "5px",
                                    outline: "none",
                                    border: "1.5px solid #1C485F",
                                    color: "#1C485F",
                                    textTransform: "none",
                                    padding: "5px 10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 21 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.4668 10H14.1335"
                                      stroke="#1C485F"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M10.8008 13.3334V6.66669"
                                      stroke="#1C485F"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.30013 18.3334H13.3001C17.4668 18.3334 19.1335 16.6667 19.1335 12.5V7.50002C19.1335 3.33335 17.4668 1.66669 13.3001 1.66669H8.30013C4.13346 1.66669 2.4668 3.33335 2.4668 7.50002V12.5C2.4668 16.6667 4.13346 18.3334 8.30013 18.3334Z"
                                      stroke="#1C485F"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Add to list
                                </button>
                              </div>
                            ) : null}
                          </TableCell> */}
                        <TableCell sx={{ padding: 0, borderBottom: "none" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "12px",
                            }}
                          >
                            <div style={{ width: "3.5vw" }}>
                              {(dataObj.Status === "Completed"||
                              (socketCount.map((val) => {
                                    if (val.id === dataObj._id) {
                                      return val.totalCount===dataObj.ToEmail.length;
                                    } 
                                  }))) && (
                                <button
                                  onClick={() => {
                                    setSelectedBulk(dataObj);
                                    setOpen3(true);
                                  }}
                                  style={{
                                    fontSize: "10px",
                                    outline: "none",
                                    textTransform: "none",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M9 11V17L11 15"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9 17L7 15"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </button>
                              )}
                              {dataObj.Status === "Pending" && (
                                <button
                                  onClick={() => {
                                    verifyBulkEmailById(dataObj._id);
                                    setSelectedBulkId(dataObj._id);
                                  }}
                                  style={{
                                    margin: "6px 0px",
                                    fontSize: "10px",
                                    borderRadius: "5px",
                                    outline: "none",
                                    color: "#fff",
                                    textTransform: "none",
                                    padding: "5px 10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                    backgroundColor: "#1C485F",
                                  }}
                                >
                                  {verifyLoader &&
                                  selectedBulkId === dataObj._id ? (
                                    <CircularProgress
                                      size={14}
                                      style={{
                                        color: "white",
                                        marginLeft: "5px",
                                        marginRight: "5px",
                                      }}
                                    />
                                  ) : (
                                    "Verify"
                                  )}
                                </button>
                              )}
                            </div>

                            <button
                              onClick={() => {
                                setOpen(true);
                                setSelectedBulkId(dataObj._id);
                              }}
                              style={{
                                fontSize: "10px",
                                outline: "none",
                                textTransform: "none",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "8px",
                                // pointerEvents:
                                //   !(
                                //     dataObj.Status === "Pending" ||
                                //     dataObj.Status === "Completed"
                                //   ) && "none",
                                // opacity:
                                //   !(
                                //     dataObj.Status === "Pending" ||
                                //     dataObj.Status === "Completed"
                                //   ) && "0.4",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                  stroke="#393939"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                  stroke="#393939"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M18.8504 9.13965L18.2004 19.2096C18.0904 20.7796 18.0004 21.9996 15.2104 21.9996H8.79039C6.00039 21.9996 5.91039 20.7796 5.80039 19.2096L5.15039 9.13965"
                                  stroke="#393939"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.3301 16.5H13.6601"
                                  stroke="#393939"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.5 12.5H14.5"
                                  stroke="#393939"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              )}
            </Table>
            {fileLists.length === 0 && (
              <div className="nodatacontainerbulk">No Data available</div>
            )}
          </TableContainer>
        </Paper>
      </Box>
    );
  };

  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        padding: "4px",
        borderRadius: "5px",
        backgroundColor: "#FFF",
        border: "1px solid #DDD",
      }}
    >
      <Box>
        <Helmet>
          <title>Email Verification</title>
          <meta name="description" content="Email campaign user all warmups" />
        </Helmet>
        <Box sx={{ backgroundColor: "#fff", borderRadius: "4px" }}>
          {displayCards()}
          {loader ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "25vh",
              }}
            >
              <CircularProgress
                size={40}
                style={{
                  color: "#1C485F",
                  marginLeft: "48px",
                  marginRight: "48px",
                }}
              />
            </div>
          ) : (
            <>
              {location.pathname === "/BulkMailVerification" ? (
                bulkUiComponent()
              ) : (
                <Mailverification data={isPassed} />
              )}
            </>
          )}
        </Box>
        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modalPopupDelete">
            <div className="modaltext">Confirm Delete ?</div>
            <div className="modalsubtext">
              Previously saved prospects won't be deleted from their prospect
              lists, but the file itself will be deleted.
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  deleteBulkFIle();
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={open3}
          onClose={() => {
            setOpen3(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="modalPopupDelete"
            style={{ width: "45vw", top: "18%", left: "30%" }}
          >
            <div className="modaltext">Download verification results</div>
            <div className="modalsubtext">
              Choose which emails you would like to download and the format of
              the exported file.
            </div>
            <div className="chooseemaillistblock">
              Choose email statuses
              <div className="emailslistdownloadbox">
                {downloadStatusArr.map((val, idx) => {
                  return (
                    <div className="downloadcheckbox">
                      <Checkbox
                        onClick={() => {
                          downloadStatusArr[idx].status =
                            !downloadStatusArr[idx].status;
                          setDownloadStatusArr([...downloadStatusArr]);
                        }}
                        checked={val.status}
                        style={{
                          color: "#1C485F",
                        }}
                      />
                      <div
                        style={{
                          height: "12px",
                          width: "12px",
                          backgroundColor: val.hex,
                          borderRadius: "20px",
                        }}
                      ></div>
                      <div className="checkdownloadlabeltext">{val.name}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="chooseemaillistblock">
              Download format options
              <div className="emailslistdownloadbox">
                {downloadFileArr.map((val, idx) => {
                  return (
                    <div className="downloadcheckbox">
                      <Radio
                        checked={fileType === val.name}
                        onClick={() => {
                          setFileType(val.name);
                        }}
                        style={{
                          color: "#1C485F",
                        }}
                      />
                      <div className="checkdownloadlabeltext">{val.name}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen3(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  let exportJson = [];
                  let copyToEmail = selectedBulk.ToEmail;

                  const promises = downloadStatusArr.map(async (val, idx) => {
                    if (idx === 0 && val.status) {
                      await Promise.all(
                        copyToEmail.map((val) => {
                          if (val.Verified) {
                            exportJson.push(val.OldValue);
                          }
                        })
                      );
                    } else if (idx === 1 && val.status) {
                      await Promise.all(
                        copyToEmail.map((val) => {
                          if (!val.Verified) {
                            exportJson.push(val.OldValue);
                          }
                        })
                      );
                    }
                  });

                  Promise.all(promises);
                  console.log("exportjson",exportJson)
                  downloadBulk(exportJson);
                }}
              >
                Download
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={open5}
          onClose={() => {
            setOpen5(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modalPopupDelete">
            <div
              className="modaltext"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "22px",
              }}
            >
              Oops ?
            </div>
            <div className="modalsubtext">
              The file was loaded in the wrong encoding. Supported encodings:
              ASCII, UTF-8, binary, ISO-8859-1.
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  setOpen5(false);
                }}
              >
                Got it
              </div>
            </div>
          </div>
        </Modal>
        {open1 && muiModal()}
        {showToaster && <ToastContainer />}
      </Box>
    </div>
  );
}
